// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c923e8b5","455":"57b956d5","977":"8347a242"}[chunkId] + ".chunk.js";
};